import VueRouter from "vue-router";
import RouterView from "@/views/RouterView.vue";
const router = new VueRouter({
    mode: "hash",
    // mode: "history",
    routes: [
        {
            path: "/",
            component: RouterView,
            children: [
                {
                    path: "/",
                    component: () => import("@/views/home/Home.vue"),
                    redirect: "/workbench",
                    children: [
                        {
                            path: "/workbench",
                            component: () => import("@/views/home/views/Workbench.vue"),
                            meta: {
                                title: "工作台",
                                keepAlive: false,
                                fatherRoute: "/workbench",
                                id: 6
                            }
                        },
                        {
                            path: "/loginLog",
                            component: () => import("@/views/home/views/LoginLog.vue"),
                            meta: {
                                title: "登录日志",
                                keepAlive: true,
                                fatherRoute: "/loginLog",
                                id: 8
                            }
                        },
                        {
                            path: "/reportCenter",
                            component: () => import("@/views/home/views/ReportCenter.vue"),
                            meta: {
                                title: "报表中心",
                                keepAlive: true,
                                fatherRoute: "/reportCenter",
                                id: 9
                            }
                        }
                    ],
                    meta: {
                        title: "首页",
                        keepAlive: true,
                        fatherRoute: "/",
                        id: 1
                    }
                },
                {
                    path: "/basicBusiness",
                    component: () => import("@/views/basicBusiness/Home.vue"),
                    redirect: "/maternityMatron",
                    children: [
                        {
                            path: "/maternityMatron",
                            component: () => import("@/views/basicBusiness/views/maternityMatron/MaternityMatron.vue"),
                            meta: {
                                title: "月嫂管理",
                                keepAlive: true,
                                fatherRoute: "/maternityMatron",
                                id: 10
                            }
                        },
                        {
                            path: "/maternityMatronDetail",
                            component: () => import("@/views/basicBusiness/views/maternityMatron/MaternityMatronDetail.vue"),
                            redirect: "/commissionRecord",
                            meta: {
                                title: "月嫂详情",
                                keepAlive: false,
                                fatherRoute: "/maternityMatron",
                                id: 10
                            },
                            children: [
                                {
                                    path: "/commissionRecord",
                                    component: () => import("@/views/basicBusiness/views/maternityMatron/detail/CommissionRecord.vue"),
                                    meta: {
                                        title: "佣金记录",
                                        keepAlive: false,
                                        fatherRoute: "/maternityMatron",
                                        id: 10
                                    },
                                },
                                {
                                    path: "/lowerLevelNanny",
                                    component: () => import("@/views/basicBusiness/views/maternityMatron/detail/LowerLevelNanny.vue"),
                                    meta: {
                                        title: "下级月嫂",
                                        keepAlive: false,
                                        fatherRoute: "/maternityMatron",
                                        id: 10
                                    },
                                },
                                {
                                    path: "/customerList",
                                    component: () => import("@/views/basicBusiness/views/maternityMatron/detail/CustomerList.vue"),
                                    meta: {
                                        title: "客户列表",
                                        keepAlive: false,
                                        fatherRoute: "/maternityMatron",
                                        id: 10
                                    },
                                },
                                {
                                    path: "/taskRecord",
                                    component: () => import("@/views/basicBusiness/views/maternityMatron/detail/TaskRecord.vue"),
                                    meta: {
                                        title: "任务记录",
                                        keepAlive: false,
                                        fatherRoute: "/maternityMatron",
                                        id: 10
                                    },
                                },
                                {
                                    path: "/welfareRedemption",
                                    component: () => import("@/views/basicBusiness/views/maternityMatron/detail/WelfareRedemption.vue"),
                                    meta: {
                                        title: "福利兑换",
                                        keepAlive: false,
                                        fatherRoute: "/maternityMatron",
                                        id: 10
                                    },
                                },
                                {
                                    path: "/activityRecord",
                                    component: () => import("@/views/basicBusiness/views/maternityMatron/detail/ActivityRecord.vue"),
                                    meta: {
                                        title: "活动记录",
                                        keepAlive: false,
                                        fatherRoute: "/maternityMatron",
                                        id: 10
                                    },
                                },
                                {
                                    path: "/violationRecord",
                                    component: () => import("@/views/basicBusiness/views/maternityMatron/detail/ViolationRecord.vue"),
                                    meta: {
                                        title: "违规记录",
                                        keepAlive: false,
                                        fatherRoute: "/maternityMatron",
                                        id: 10
                                    },
                                },
                                {
                                    path: "/operationRecord",
                                    component: () => import("@/views/basicBusiness/views/maternityMatron/detail/OperationRecord.vue"),
                                    meta: {
                                        title: "操作记录",
                                        keepAlive: false,
                                        fatherRoute: "/maternityMatron",
                                        id: 10
                                    },
                                }
                            ]
                        },
                        {
                            path: "/addANewNanny",
                            component: () => import("@/views/basicBusiness/views/maternityMatron/AddANewNanny.vue"),
                            meta: {
                                title: "新增月嫂",
                                keepAlive: false,
                                fatherRoute: "/maternityMatron",
                                id: 10
                            }
                        },
                        {
                            path: "/customer",
                            component: () => import("@/views/basicBusiness/views/customer/Customer.vue"),
                            meta: {
                                title: "客户管理",
                                keepAlive: true,
                                fatherRoute: "/customer",
                                id: 11
                            }
                        },
                        {
                            path: "/addCustomer",
                            component: () => import("@/views/basicBusiness/views/customer/AddCustomer.vue"),
                            meta: {
                                title: "新增客户",
                                keepAlive: false,
                                fatherRoute: "/customer",
                                id: 11
                            }
                        },
                        {
                            path: "/customerDetail",
                            component: () => import("@/views/basicBusiness/views/customer/CustomerDetail.vue"),
                            redirect: "/customerCommissionRecord",
                            meta: {
                                title: "客户详情",
                                keepAlive: false,
                                fatherRoute: "/customer",
                                id: 11
                            },
                            children: [
                                {
                                    path: "/customerCommissionRecord",
                                    component: () => import("@/views/basicBusiness/views/customer/detail/CommissionRecord.vue"),
                                    meta: {
                                        title: "佣金记录",
                                        keepAlive: false,
                                        fatherRoute: "/customer",
                                        id: 11
                                    },
                                },
                                {
                                    path: "/customerShootOrder",
                                    component: () => import("@/views/basicBusiness/views/customer/detail/ShootOrder.vue"),
                                    meta: {
                                        title: "拍摄订单",
                                        keepAlive: false,
                                        fatherRoute: "/customer",
                                        id: 11
                                    },
                                },
                                {
                                    path: "/customerMallOrders",
                                    component: () => import("@/views/basicBusiness/views/customer/detail/MallOrders.vue"),
                                    meta: {
                                        title: "商城订单",
                                        keepAlive: false,
                                        fatherRoute: "/customer",
                                        id: 11
                                    },
                                },
                                {
                                    path: "/pictureRecording",
                                    component: () => import("@/views/basicBusiness/views/customer/detail/PictureRecording.vue"),
                                    meta: {
                                        title: "图片记录",
                                        keepAlive: false,
                                        fatherRoute: "/customer",
                                        id: 11
                                    },
                                },
                                {
                                    path: "/customerOperationRecord",
                                    component: () => import("@/views/basicBusiness/views/customer/detail/OperationRecord.vue"),
                                    meta: {
                                        title: "操作记录",
                                        keepAlive: false,
                                        fatherRoute: "/customer",
                                        id: 11
                                    },
                                }

                            ]
                        },
                        {
                            path: "/shootingSheet",
                            component: () => import("@/views/basicBusiness/views/shootingSheet/ShootingSheet.vue"),
                            meta: {
                                title: "拍摄单管理",
                                keepAlive: true,
                                fatherRoute: "/shootingSheet"
                            }

                        },
                        {
                            path: "/taskCenter",
                            component: () => import("@/views/basicBusiness/views/taskCenter/TaskCenter.vue"),
                            meta: {
                                title: "任务中心",
                                keepAlive: true,
                                fatherRoute: "/taskCenter",
                                id: 12
                            }
                        },
                        {
                            path: "/addTaskCenter",
                            component: () => import("@/views/basicBusiness/views/taskCenter/AddTaskCenter.vue"),
                            meta: {
                                title: "任务中心",
                                keepAlive: false,
                                fatherRoute: "/taskCenter",
                                id: 12
                            }
                        },
                        {
                            path: "/taskCenterDetail",
                            component: () => import("@/views/basicBusiness/views/taskCenter/TaskCenterDetail.vue"),
                            redirect: "/completedNumberOfPeople",
                            meta: {
                                title: "任务详情",
                                keepAlive: false,
                                fatherRoute: "/taskCenter",
                                id: 12
                            },
                            children: [
                                {
                                    path: "/completedNumberOfPeople",
                                    component: () => import("@/views/basicBusiness/views/taskCenter/detail/CompletedNumberOfPeople.vue"),
                                    meta: {
                                        title: "已完成人数",
                                        keepAlive: false,
                                        fatherRoute: "/taskCenter",
                                        id: 12
                                    }
                                },
                                {
                                    path: "/numberOfUnfinishedTasks",
                                    component: () => import("@/views/basicBusiness/views/taskCenter/detail/NumberOfUnfinishedTasks.vue"),
                                    meta: {
                                        title: "未完成人数",
                                        keepAlive: false,
                                        fatherRoute: "/taskCenter",
                                        id: 12
                                    }
                                },
                                {
                                    path: "/taskCenterOperationRecord",
                                    component: () => import("@/views/basicBusiness/views/taskCenter/detail/OperationRecord.vue"),
                                    meta: {
                                        title: "操作记录",
                                        keepAlive: false,
                                        fatherRoute: "/taskCenter",
                                        id: 12
                                    }
                                }
                            ]
                        },
                        {
                            path: "/activity",
                            component: () => import("@/views/basicBusiness/views/activity/Activity.vue"),
                            meta: {
                                title: "活动管理",
                                keepAlive: true,
                                fatherRoute: "/activity",
                                id: 13
                            }
                        },
                        {
                            path: "/addActivity",
                            component: () => import("@/views/basicBusiness/views/activity/AddActivity.vue"),
                            meta: {
                                title: "新增活动",
                                keepAlive: false,
                                fatherRoute: "/activity",
                                id: 13
                            }
                        },
                        {
                            path: "/activityDetail",
                            component: () => import("@/views/basicBusiness/views/activity/ActivityDetail.vue"),
                            redirect: "/activityContent",
                            meta: {
                                title: "活动详情",
                                keepAlive: false,
                                fatherRoute: "/activity",
                                id: 13
                            },
                            children: [
                                {
                                    path: "/activityContent",
                                    component: () => import("@/views/basicBusiness/views/activity/detail/ActivityContent.vue"),
                                    meta: {
                                        title: "活动内容",
                                        keepAlive: false,
                                        fatherRoute: "/activity",
                                        id: 13
                                    }
                                },
                                {
                                    path: "/participants",
                                    component: () => import("@/views/basicBusiness/views/activity/detail/Participants.vue"),
                                    meta: {
                                        title: "参加人员",
                                        keepAlive: false,
                                        fatherRoute: "/activity",
                                        id: 13
                                    }
                                },
                                {
                                    path: "/qrCode",
                                    component: () => import("@/views/basicBusiness/views/activity/detail/QrCode.vue"),
                                    meta: {
                                        title: "签到二维码",
                                        keepAlive: false,
                                        fatherRoute: "/activity",
                                        id: 13
                                    }
                                },
                                {
                                    path: "/activityOperationRecord",
                                    component: () => import("@/views/basicBusiness/views/activity/detail/OperationRecord.vue"),
                                    meta: {
                                        title: "操作记录",
                                        keepAlive: false,
                                        fatherRoute: "/activity",
                                        id: 13
                                    }
                                }
                            ]
                        },
                        {
                            path: "/store",
                            component: () => import("@/views/basicBusiness/views/store/Store.vue"),
                            meta: {
                                title: "门店管理",
                                keepAlive: true,
                                fatherRoute: "/store",
                                id: 14
                            }
                        },
                        {
                            path: "/addStore",
                            component: () => import("@/views/basicBusiness/views/store/AddStore.vue"),
                            meta: {
                                title: "新增门店",
                                keepAlive: false,
                                fatherRoute: "/store",
                                id: 14
                            }
                        },
                        {
                            path: "/storeDetail",
                            component: () => import("@/views/basicBusiness/views/store/StoreDetail.vue"),
                            redirect: "/storeCommissionRecord",
                            meta: {
                                title: "门店详情",
                                keepAlive: false,
                                fatherRoute: "/store",
                                id: 14
                            },
                            children: [
                                {
                                    path: "/storeCommissionRecord",
                                    component: () => import("@/views/basicBusiness/views/store/detail/CommissionRecord.vue"),
                                    meta: {
                                        title: "佣金记录",
                                        keepAlive: false,
                                        fatherRoute: "/store",
                                        id: 14
                                    }
                                },
                                {
                                    path: "/storeMallOrders",
                                    component: () => import("@/views/basicBusiness/views/store/detail/MallOrders.vue"),
                                    meta: {
                                        title: "商城订单",
                                        keepAlive: false,
                                        fatherRoute: "/store",
                                        id: 14
                                    }
                                },
                                {
                                    path: "/storeOperationRecord",
                                    component: () => import("@/views/basicBusiness/views/store/detail/OperationRecord.vue"),
                                    meta: {
                                        title: "操作记录",
                                        keepAlive: false,
                                        fatherRoute: "/store",
                                        id: 14
                                    }
                                }
                            ]
                        },
                        {
                            path: "/learningGarden",
                            component: () => import("@/views/basicBusiness/views/learningGarden/LearningGarden.vue"),
                            meta: {
                                title: "学习园地",
                                keepAlive: true,
                                fatherRoute: "/learningGarden",
                                id: 15
                            }

                        },
                        {
                            path: "/addLearningGarden",
                            component: () => import("@/views/basicBusiness/views/learningGarden/AddLearningGarden.vue"),
                            meta: {
                                title: "新增学习园地",
                                keepAlive: false,
                                fatherRoute: "/learningGarden",
                                id: 15
                            }

                        },
                        {
                            path: "/help",
                            component: () => import("@/views/basicBusiness/views/help/Help.vue"),
                            meta: {
                                title: "爱心帮扶",
                                keepAlive: false,
                                fatherRoute: "/help",
                                id: 16
                            }
                        },
                        {
                            path: "/helpDetail",
                            component: () => import("@/views/basicBusiness/views/help/HelpDetail.vue"),
                            redirect: "/helpInformation",
                            meta: {
                                title: "处理详情",
                                keepAlive: false,
                                fatherRoute: "/help",
                                id: 16
                            },
                            children: [
                                {
                                    path: "/helpInformation",
                                    component: () => import("@/views/basicBusiness/views/help/detail/HelpInformation.vue"),
                                    meta: {
                                        title: "求助信息",
                                        keepAlive: false,
                                        fatherRoute: "/help",
                                        id: 16
                                    }
                                },
                                {
                                    path: "/helpProcess",
                                    component: () => import("@/views/basicBusiness/views/help/detail/HelpProcess.vue"),
                                    meta: {
                                        title: "处理过程",
                                        keepAlive: false,
                                        fatherRoute: "/help",
                                        id: 16
                                    }
                                },
                                {
                                    path: "/helpOperationRecord",
                                    component: () => import("@/views/basicBusiness/views/help/detail/OperationRecord.vue"),
                                    meta: {
                                        title: "操作记录",
                                        keepAlive: false,
                                        fatherRoute: "/help",
                                        id: 16
                                    }
                                }
                            ]
                        },
                    ],
                    meta: {
                        title: "基础业务",
                        keepAlive: true,
                        fatherRoute: "/basicBusiness",
                        id: 2
                    }
                },
                {
                    path: "/shoppingMall",
                    component: () => import("@/views/shoppingMall/Home.vue"),
                    redirect: "/productManagement",
                    children: [
                        {
                            path: "/productManagement",
                            component: () => import("@/views/shoppingMall/views/productManagement/ProductManagement.vue"),
                            meta: {
                                title: "商品管理",
                                keepAlive: true,
                                fatherRoute: "/productManagement",
                                id: 17
                            }
                        },
                        {
                            path: "/addProductManagement",
                            component: () => import("@/views/shoppingMall/views/productManagement/AddProductManagement.vue"),
                            meta: {
                                title: "新增商品",
                                keepAlive: false,
                                fatherRoute: "/productManagement",
                                id: 17
                            }
                        },
                        {
                            path: "/productCategory",
                            component: () => import("@/views/shoppingMall/views/productCategory/ProductCategory.vue"),
                            meta: {
                                title: "商品类目",
                                keepAlive: true,
                                fatherRoute: "/productCategory",
                                id: 18
                            }
                        },
                        {
                            path: "/orderManagement",
                            component: () => import("@/views/shoppingMall/views/orderManagement/OrderManagement.vue"),
                            meta: {
                                title: "订单管理",
                                keepAlive: true,
                                fatherRoute: "/orderManagement",
                                id: 19
                            }
                        },
                        {
                            path: "/orderManagementDetail",
                            component: () => import("@/views/shoppingMall/views/orderManagement/OrderManagementDetail.vue"),
                            meta: {
                                title: "订单详情",
                                keepAlive: false,
                                fatherRoute: "/orderManagement",
                                id: 19
                            }
                        },
                        {
                            path: "/afterSalesOrder",
                            component: () => import("@/views/shoppingMall/views/afterSalesOrder/AfterSalesOrder.vue"),
                            meta: {
                                title: "售后订单",
                                keepAlive: true,
                                fatherRoute: "/afterSalesOrder",
                                id: 20
                            }
                        },
                        {
                            path: "/afterSalesOrderDetail",
                            component: () => import("@/views/shoppingMall/views/afterSalesOrder/AfterSalesOrderDetail.vue"),
                            meta: {
                                title: "售后订单详情",
                                keepAlive: false,
                                fatherRoute: "/afterSalesOrder",
                                id: 20
                            }
                        },
                        {
                            path: "/welfareVerification",
                            component: () => import("@/views/shoppingMall/views/welfareVerification/WelfareVerification.vue"),
                            meta: {
                                title: "福利核销",
                                keepAlive: true,
                                fatherRoute: "/welfareVerification",
                                id: 21
                            }
                        },
                        {
                            path: "/timeLimitedFlashSale",
                            component: () => import("@/views/shoppingMall/views/marketingSettings/TimeLimitedFlashSale.vue"),
                            meta: {
                                title: "限时秒杀",
                                keepAlive: true,
                                fatherRoute: "/marketingSettings",
                                id: 22
                            }
                        },
                        {
                            path: "/addTimeLimitedFlashSale",
                            component: () => import("@/views/shoppingMall/views/marketingSettings/AddTimeLimitedFlashSale.vue"),
                            meta: {
                                title: "新增限时秒杀",
                                keepAlive: false,
                                fatherRoute: "/marketingSettings",
                                id: 22
                            }
                        },
                        {
                            path: "/exclusiveForNewcomers",
                            component: () => import("@/views/shoppingMall/views/marketingSettings/ExclusiveForNewcomers.vue"),
                            meta: {
                                title: "新人专享",
                                keepAlive: true,
                                fatherRoute: "/marketingSettings",
                                id: 23
                            }
                        },
                        {
                            path: "/freeShipping",
                            component: () => import("@/views/shoppingMall/views/marketingSettings/FreeShipping.vue"),
                            meta: {
                                title: "9.9包邮",
                                keepAlive: true,
                                fatherRoute: "/marketingSettings",
                                id: 24
                            }
                        },
                        {
                            path: "/addFreeShipping",
                            component: () => import("@/views/shoppingMall/views/marketingSettings/AddFreeShipping.vue"),
                            meta: {
                                title: "新增9.9包邮",
                                keepAlive: false,
                                fatherRoute: "/marketingSettings",
                                id: 24
                            }
                        },
                        {
                            path: "/addExclusiveForNewcomers",
                            component: () => import("@/views/shoppingMall/views/marketingSettings/AddExclusiveForNewcomers.vue"),
                            meta: {
                                title: "新增新人专享",
                                keepAlive: false,
                                fatherRoute: "/marketingSettings",
                                id: 23
                            }
                        },
                        {
                            path: "/coupon",
                            component: () => import("@/views/shoppingMall/views/coupon/Coupon.vue"),
                            meta: {
                                title: "优惠卷",
                                keepAlive: true,
                                fatherRoute: "/coupon",
                                id: 27
                            }
                        },
                        {
                            path: "/addConpon",
                            component: () => import("@/views/shoppingMall/views/coupon/AddConpon.vue"),
                            meta: {
                                title: "新增优惠卷",
                                keepAlive: false,
                                fatherRoute: "/coupon",
                                id: 27
                            }
                        },
                        {
                            path: "/notice",
                            component: () => import("@/views/shoppingMall/views/notice/Notice.vue"),
                            meta: {
                                title: "公告管理",
                                keepAlive: true,
                                fatherRoute: "/notice",
                                id: 28
                            }
                        },
                        {
                            path: "/addNotice",
                            component: () => import("@/views/shoppingMall/views/notice/AddNotice.vue"),
                            meta: {
                                title: "新增公告管理",
                                keepAlive: false,
                                fatherRoute: "/notice",
                                id: 28
                            }
                        },
                        {
                            path: "/carousel",
                            component: () => import("@/views/shoppingMall/views/carousel/Carousel.vue"),
                            meta: {
                                title: "轮播图",
                                keepAlive: true,
                                fatherRoute: "/carousel",
                                id: 25
                            }
                        },
                        {
                            path: "/addCarousel",
                            component: () => import("@/views/shoppingMall/views/carousel/AddCarousel.vue"),
                            meta: {
                                title: "新增轮播图",
                                keepAlive: false,
                                fatherRoute: "/carousel",
                                id: 25
                            }
                        },
                        {
                            path: "/member",
                            component: () => import("@/views/shoppingMall/views/member/Member.vue"),
                            meta: {
                                title: "会员设置",
                                keepAlive: true,
                                fatherRoute: "/member",
                                id: 26
                            }
                        },
                        {
                            path: "/editMember",
                            component: () => import("@/views/shoppingMall/views/member/EditMember.vue"),
                            meta: {
                                title: "编辑会员设置",
                                keepAlive: false,
                                fatherRoute: "/member",
                                id: 26
                            }
                        },
                    ],
                    meta: {
                        title: "云暖商城",
                        keepAlive: true,
                        fatherRoute: "/shoppingMall",
                        id: 3
                    }
                },
                {
                    path: "/distribution",
                    component: () => import("@/views/distribution/Home.vue"),
                    redirect: "/distributionSettings",
                    children: [
                        {
                            path: "/distributionSettings",
                            component: () => import("@/views/distribution/views/distributionSettings/DistributionSettings.vue"),
                            meta: {
                                title: "分销设置",
                                keepAlive: false,
                                fatherRoute: "/distributionSettings",
                                id: 29
                            }
                        },
                        {
                            path: "/customCommission",
                            component: () => import("@/views/distribution/views/customCommission/CustomCommission.vue"),
                            meta: {
                                title: "自定义佣金",
                                keepAlive: true,
                                fatherRoute: "/customCommission",
                                id: 30
                            }
                        },
                        {
                            path: "/distributionOrder",
                            component: () => import("@/views/distribution/views/distributionOrder/DistributionOrder.vue"),
                            meta: {
                                title: "分销订单",
                                keepAlive: true,
                                fatherRoute: "/distributionOrder",
                                id: 31
                            }
                        },
                        {
                            path: "/addDistributionOrder",
                            component: () => import("@/views/distribution/views/distributionOrder/AddDistributionOrder.vue"),
                            meta: {
                                title: "新增分销订单",
                                keepAlive: false,
                                fatherRoute: "/distributionOrder",
                                id: 31
                            }
                        },
                        {
                            path: "/commissionWithdrawal",
                            component: () => import("@/views/distribution/views/commissionWithdrawal/CommissionWithdrawal.vue"),
                            meta: {
                                title: "佣金提现",
                                keepAlive: false,
                                fatherRoute: "/commissionWithdrawal",
                                id: 32
                            }
                        },
                        {
                            path: "/commissionWithdrawalDetail",
                            component: () => import("@/views/distribution/views/commissionWithdrawal/CommissionWithdrawalDetail.vue"),
                            redirect: "/commissionWithdrawalDistributionOrder",
                            meta: {
                                title: "佣金提现",
                                keepAlive: false,
                                fatherRoute: "/commissionWithdrawal",
                                id: 32
                            },
                            children: [
                                {
                                    path: "/commissionWithdrawalDistributionOrder",
                                    component: () => import("@/views/distribution/views/commissionWithdrawal/detail/DistributionOrder.vue"),
                                    meta: {
                                        title: "参加人员",
                                        keepAlive: false,
                                        fatherRoute: "/commissionWithdrawal",
                                        id: 32
                                    }
                                },
                                {
                                    path: "/transferVoucher",
                                    component: () => import("@/views/distribution/views/commissionWithdrawal/detail/TransferVoucher.vue"),
                                    meta: {
                                        title: "转账凭证",
                                        keepAlive: false,
                                        fatherRoute: "/commissionWithdrawal",
                                        id: 32
                                    }
                                },
                                {
                                    path: "/transferVoucher2",
                                    component: () => import("@/views/distribution/views/commissionWithdrawal/detail/TransferVoucher2.vue"),
                                    meta: {
                                        title: "驳回原因",
                                        keepAlive: false,
                                        fatherRoute: "/commissionWithdrawal",
                                        id: 32
                                    }
                                },
                                {
                                    path: "/commissionWithdrawalOperationRecord",
                                    component: () => import("@/views/distribution/views/commissionWithdrawal/detail/OperationRecord.vue"),
                                    meta: {
                                        title: "操作记录",
                                        keepAlive: false,
                                        fatherRoute: "/commissionWithdrawal",
                                        id: 32
                                    }
                                }
                            ]
                        },
                        {
                            path: "/distributor",
                            component: () => import("@/views/distribution/views/distributor/MaternityMatron.vue"),
                            meta: {
                                title: "分销员",
                                keepAlive: true,
                                fatherRoute: "/distributor",
                                id: 63
                            }
                        },
                        {
                            path: "/distributionMatronDetail",
                            component: () => import("@/views/distribution/views/distributor/MaternityMatronDetail.vue"),
                            redirect: "/distributionCommissionRecord",
                            meta: {
                                title: "分销员详情",
                                keepAlive: false,
                                fatherRoute: "/distributor",
                                id: 63
                            },
                            children: [
                                {
                                    path: "/distributionCommissionRecord",
                                    component: () => import("@/views/distribution/views/distributor/detail/CommissionRecord.vue"),
                                    meta: {
                                        title: "佣金记录",
                                        keepAlive: false,
                                        fatherRoute: "/distributor",
                                        id: 63
                                    },
                                },
                                {
                                    path: "/distributionLowerLevelNanny",
                                    component: () => import("@/views/distribution/views/distributor/detail/LowerLevelNanny.vue"),
                                    meta: {
                                        title: "下级月嫂",
                                        keepAlive: false,
                                        fatherRoute: "/distributor",
                                        id: 63
                                    },
                                },
                                {
                                    path: "/distributionCustomerList",
                                    component: () => import("@/views/distribution/views/distributor/detail/CustomerList.vue"),
                                    meta: {
                                        title: "客户列表",
                                        keepAlive: false,
                                        fatherRoute: "/distributor",
                                        id: 63
                                    },
                                },
                                {
                                    path: "/distributionTaskRecord",
                                    component: () => import("@/views/distribution/views/distributor/detail/TaskRecord.vue"),
                                    meta: {
                                        title: "任务记录",
                                        keepAlive: false,
                                        fatherRoute: "/distributor",
                                        id: 63
                                    },
                                },
                                {
                                    path: "/distributionWelfareRedemption",
                                    component: () => import("@/views/distribution/views/distributor/detail/WelfareRedemption.vue"),
                                    meta: {
                                        title: "福利兑换",
                                        keepAlive: false,
                                        fatherRoute: "/distributor",
                                        id: 63
                                    },
                                },
                                {
                                    path: "/distributionActivityRecord",
                                    component: () => import("@/views/distribution/views/distributor/detail/ActivityRecord.vue"),
                                    meta: {
                                        title: "活动记录",
                                        keepAlive: false,
                                        fatherRoute: "/distribution",
                                        id: 63
                                    },
                                },
                                {
                                    path: "/distributionViolationRecord",
                                    component: () => import("@/views/distribution/views/distributor/detail/ViolationRecord.vue"),
                                    meta: {
                                        title: "违规记录",
                                        keepAlive: false,
                                        fatherRoute: "/distributor",
                                        id: 63
                                    },
                                },
                                {
                                    path: "/distributionOperationRecord",
                                    component: () => import("@/views/distribution/views/distributor/detail/OperationRecord.vue"),
                                    meta: {
                                        title: "操作记录",
                                        keepAlive: false,
                                        fatherRoute: "/distributor",
                                        id: 63
                                    },
                                }
                            ]
                        },
                        {
                            path: "/distributionAddANewNanny",
                            component: () => import("@/views/distribution/views/distributor/AddANewNanny.vue"),
                            meta: {
                                title: "新增月嫂",
                                keepAlive: false,
                                fatherRoute: "/distributor",
                                id: 10
                            }
                        },
                    ],
                    meta: {
                        title: "分销管理",
                        keepAlive: true,
                        fatherRoute: "/distribution",
                        id: 4
                    }
                },
                {
                    path: "/systemSettings",
                    component: () => import("@/views/systemSettings/Home.vue"),
                    redirect: "/roleAuthorization",
                    children: [
                        {
                            path: "/roleAuthorization",
                            component: () => import("@/views/systemSettings/views/roleAuthorization/RoleAuthorization.vue"),
                            meta: {
                                title: "角色授权",
                                keepAlive: false,
                                fatherRoute: "/roleAuthorization",
                                id: 33
                            }
                        },
                        {
                            path: "/employeeAccount",
                            component: () => import("@/views/systemSettings/views/employeeAccount/EmployeeAccount.vue"),
                            meta: {
                                title: "员工账号",
                                keepAlive: true,
                                fatherRoute: "/employeeAccount",
                                id: 34
                            }
                        },
                        {
                            path: "/addAccount",
                            component: () => import("@/views/systemSettings/views/employeeAccount/AddAccount.vue"),
                            meta: {
                                title: "员工账号",
                                keepAlive: false,
                                fatherRoute: "/employeeAccount",
                                id: 34
                            }
                        },
                        {
                            path: "/pointsManagement",
                            component: () => import("@/views/systemSettings/views/pointsManagement/PointsManagement.vue"),
                            meta: {
                                title: "积分管理",
                                keepAlive: false,
                                fatherRoute: "/pointsManagement",
                                id: 35
                            }
                        },
                        {
                            path: "/dataDictionary",
                            component: () => import("@/views/systemSettings/views/dataDictionary/DataDictionary.vue"),
                            meta: {
                                title: "数据字典",
                                keepAlive: false,
                                fatherRoute: "/dataDictionary",
                                id: 36
                            }
                        },
                        {
                            path: "/activitySetting",
                            component: () => import("@/views/systemSettings/views/activitySetting/ActivitySetting.vue"),
                            meta: {
                                title: "活跃度设置",
                                keepAlive: false,
                                fatherRoute: "/activitySetting",
                                id: 37
                            }
                        },
                        {
                            path: "/eventDisclaimer",
                            component: () => import("@/views/systemSettings/views/eventDisclaimer/EventDisclaimer.vue"),
                            meta: {
                                title: "活动免责声明",
                                keepAlive: false,
                                fatherRoute: "/eventDisclaimer",
                                id: 38
                            }
                        },
                        {
                            path: "/returnSetting",
                            component: () => import("@/views/systemSettings/views/returnSetting/ReturnSetting.vue"),
                            meta: {
                                title: "退货设置",
                                keepAlive: false,
                                fatherRoute: "/returnSetting",
                                id: 66
                            }
                        },
                    ],
                    meta: {
                        title: "系统设置",
                        keepAlive: true,
                        fatherRoute: "/systemSettings",
                        id: 5
                    }
                },
                {
                    path: "/message",
                    component: () => import("@/views/message/Home.vue"),
                    redirect: "/unreadMessage",
                    children: [
                        {
                            path: "/unreadMessage",
                            component: () => import("@/views/message/views/UnreadMessage.vue"),
                            meta: {
                                title: "未读消息",
                                keepAlive: false,
                                fatherRoute: "/unreadMessage",
                                id: 64
                            }
                        },
                        {
                            path: "/readMessages",
                            component: () => import("@/views/message/views/ReadMessages.vue"),
                            meta: {
                                title: "已读消息",
                                keepAlive: false,
                                fatherRoute: "/readMessages",
                                id: 64
                            }
                        },
                    ],
                    meta: {
                        title: "消息通知",
                        keepAlive: true,
                        fatherRoute: "/message",
                        id: 64
                    }
                }
            ]
        },
        {
            path: "/login",
            component: () => import("@/views/login/Login.vue"),
            meta: {
                title: "登录"
            }
        },
        {
            path: "/forgotPassword",
            component: () => import("@/views/login/ForgotPassword.vue"),
            meta: {
                title: "忘记密码"
            }
        },
        //登录
        {
            path: "/indexpdf",
            name: "indexpdf",
            component: () => import('@/views/Index.vue')
        },
    ]
})
export default router
